import classNames from 'classnames';
import styles from './index.module.sass';
import { useState } from 'react';

export const TabsBar = ({
  activeItem,
  tabs,
  setActiveTab,
  controls,
}: {
  activeItem: number;
  setActiveTab: (id: number) => void;
  tabs: { label: string; id: number; disabled?: boolean }[];
  controls?: JSX.Element;
}) => {

  return (
    <div className={styles.root}>
      <div className={styles.tabsWrap}>
        {tabs.map((item, i) => (
          <div
            key={i}
            onClick={() => (item.disabled ? null : setActiveTab(item.id))}
            className={classNames(
              styles.tab__item,
              activeItem === item.id && styles.tab__active,
              activeItem === item.id && styles.premarker,
              item.disabled && styles.disabled,
            )}
          >
            {item.label}
            {item.id === activeItem && <div className={styles.underliner}></div>}
          </div>
        ))}
      </div>
      { controls && <div className={styles.controlWrap}>
        { controls }
      </div>}
    </div>
  );
};
